function getGlobalThis(): typeof globalThis {
  // eslint-disable-next-line no-restricted-globals
  if (typeof globalThis !== 'undefined') return globalThis;
  // eslint-disable-next-line unicorn/prefer-global-this
  if (typeof window !== 'undefined') return window as any;
  // eslint-disable-next-line unicorn/prefer-global-this
  if (typeof global !== 'undefined') return global as any;
  // eslint-disable-next-line unicorn/prefer-global-this
  if (typeof self !== 'undefined') return self as any;
  throw new Error('Unable to locate global object');
}

/**
 * Provides a safe reference to the global object APIs across all environments.
 *
 * `globalThis` is a standard built-in JavaScript object that always refers to the global object of the current
 * environment, regardless of whether your code runs in a browser, Node.js, a worker, or a module.
 *
 * But `globalThis` was introduced in ES2020, and older platforms like Tizen 2016 (Chromium ~2015-2016) do not support
 * it. Rather than bundling a full polyfill into the library, this helper resolves the global object at runtime by
 * checking the available global references in order: `globalThis` → `window` → `global` → `self`.
 *
 * This improves:
 * - compatibility with various environments where the `window` global variable may not be available (VegaOS, React Native)
 * - testability by allowing easy mocking of global object functionality.
 */
export const globalScope = getGlobalThis();
